import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ms_drawer = _resolveComponent("ms-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_ms_drawer, {
      modelValue: $setup.drawerVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.drawerVisible) = $event)),
      direction: "rtl",
      size: "500px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          src: $setup.helpSrc,
          width: "100%",
          height: "100%",
          frameBorder: "0"
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}